import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';
import { Money } from '@dreryk/money-common-api';
import { AppointmentAdvancePaymentOnlinePayment } from '@dreryk/egabinet-appointment-advance-payment-frontend-api';

import { RotateRightIcon } from '@dreryk/react-components';

import { AppointmentAdvancePaymentShowModalEventInterceptor } from '../interceptors/AppointmentAdvancePaymentShowModalEventInterceptor';
import { advancePaymentStatusVisitor } from '../shared/advancePaymentStatusVisitor';
import { translationKeys } from '../translations';

import { AdvancePaymentActionTrigger, AdvancePaymentActionVariant } from './AdvancePaymentActionTrigger';
import { AdvancePaymentIssueUnderpaymentLinks } from './AdvancePaymentIssueUnderpaymentLinks';

type AdvancePaymentIssueActionLinkProps = {
   appointmentId: AppointmentId;
   paidAmount: Money;
   requiredAmount: Money;
   refundToBeCreatedAmount?: Money;
   remainingAmount: Money;
   pendingOnlinePayments?: AppointmentAdvancePaymentOnlinePayment[];
   variant?: AdvancePaymentActionVariant;
};

export const AdvancePaymentIssueActionLink = (props: AdvancePaymentIssueActionLinkProps): JSX.Element | null => {
   const variant = props.variant ?? 'link';

   return advancePaymentStatusVisitor(
      {
         requiredAmount: props.requiredAmount,
         paidAmount: props.paidAmount,
      },
      {
         visitPaid: () => null,
         visitUnderpayment: () => (
            <AdvancePaymentIssueUnderpaymentLinks
               variant={variant}
               appointmentId={props.appointmentId}
               remainingAmount={props.remainingAmount}
               pendingOnlinePayments={props.pendingOnlinePayments}
            />
         ),
         visitOverpayment: () => (
            <AppointmentAdvancePaymentShowModalEventInterceptor appointmentId={props.appointmentId}>
               <AdvancePaymentActionTrigger
                  variant={variant}
                  testId={'returnOverpayment'}
                  label={translationKeys.returnOverpayment}
                  icon={<RotateRightIcon />}
               />
            </AppointmentAdvancePaymentShowModalEventInterceptor>
         ),
      }
   );
};
